import { render, staticRenderFns } from "./oilIntention.vue?vue&type=template&id=99c14d02&scoped=true&"
import script from "./oilIntention.vue?vue&type=script&lang=js&"
export * from "./oilIntention.vue?vue&type=script&lang=js&"
import style0 from "./oilIntention.vue?vue&type=style&index=0&id=99c14d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c14d02",
  null
  
)

export default component.exports